<script setup lang="ts">
import StackLayout from '@/components/Layouts/StackLayout.vue'
import { TypographyItem, TypographyWithPrefix } from '@/components/Typography'
import moment from 'moment'
import DividerItem from '../../../../../components/Divider/DividerItem.vue'
import type { RentalPeriod } from '../../../../../types/models/DeviceRentalPeriods'
import { DATETIME_FORMAT } from '../../../../../utils/dateUtils'

type Props = {
    periods: RentalPeriod[]
}
defineProps<Props>()
</script>

<template>
    <StackLayout direction="column">
        <TypographyItem :label="$t('device.rental.unavailable')" />
        <StackLayout direction="column" v-for="(unavailablePeriod, index) in periods" :key="index">
            <TypographyWithPrefix
                :prefix="$t('date.start')"
                :label="moment(unavailablePeriod.start).format(DATETIME_FORMAT)" />
            <TypographyWithPrefix
                :prefix="$t('date.end')"
                :label="moment(unavailablePeriod.end).format(DATETIME_FORMAT)" />
            <TypographyItem :label="unavailablePeriod.reason" />
            <DividerItem v-if="index + 1 !== periods.length" />
        </StackLayout>
    </StackLayout>
</template>
